// extracted by mini-css-extract-plugin
module.exports = {"overlay":"RemovedItems_overlay__IDa0v","content":"RemovedItems_content__pBGF1"};